import React, { useEffect, useRef, useState } from 'react';
import { AUITable } from '@ancert/aui-table';
import { arrayOf, func, shape } from 'prop-types';
import { useNotification } from '@ancert/aui-notification-context';
import {
  AUICalendarFilter,
  AUIClearFilter,
  AUIFilterBar,
  AUISearchFilter,
  AUISelectFilter,
  AUIWrapperFilter,
} from '@ancert/aui-filter-bar';
import getColumns from './columns';
import { SEARCH_OPTIONS, SELECT_OPTIONS, generateFilter, localFilterData } from './filter';
import { getDenuncias } from '../../../../../services/denuncias.service';
import { PAGE_SIZE } from '../../../../../config';
import { ROL } from '../../../../../lib/role.enum';
import { useSession } from '../../../../../context/session.context';

const AsignarDenuncia = ({ complaintSelected, setComplaintSelected }) => {
  const tableRef = useRef(null);
  const { openNotification } = useNotification();
  const { getUser } = useSession();
  const { role } = getUser();
  const [listadoData, setListadoData] = useState([]);
  const [dataFilter, setDataFilter] = useState(null);
  const dataFiltered = localFilterData({
    data: listadoData,
    filter: dataFilter,
    idPermission: [ROL.ADMINISTRADOR, ROL.RESPONSABLE].includes(role),
  });

  const getData = async () => {
    const { status, data: result, error } = await getDenuncias();
    if (status === 200) {
      setListadoData(result);
      return;
    }
    const { message } = error;
    openNotification({
      title: 'Error',
      content: <div>{message || 'Ha ocurrido un error al recuperar los datos.'}</div>,
      type: 'error',
      centerButtons: true,
    });
  };

  const onAsignar = (value) => {
    const newData = [...complaintSelected, value];
    setComplaintSelected(newData);
  };

  useEffect(() => {
    getData();
  }, []);

  const onApplyFilter = (filter) => {
    const applyFilter = generateFilter(filter);
    setDataFilter(applyFilter);
    tableRef.current.resetPagination();
  };

  return (
    <div>
      <h3>Asignación de denuncias</h3>
      <AUIFilterBar
        tagBar
        className="u-mt-16"
        onSubmit={onApplyFilter}
        onReset={() => {
          setDataFilter(null);
        }}
      >
        <AUIWrapperFilter position="left">
          <AUISearchFilter name="filter" options={SEARCH_OPTIONS} />
        </AUIWrapperFilter>
        <AUIWrapperFilter position="center">
          <AUICalendarFilter name="date" label="Fecha denuncia" selectionMode="range" />
          <AUISelectFilter label="Estado" name="status" options={SELECT_OPTIONS} />
        </AUIWrapperFilter>
        <AUIWrapperFilter position="right">
          <AUIClearFilter label="Reiniciar filtros" />
        </AUIWrapperFilter>
      </AUIFilterBar>
      <AUITable
        ref={tableRef}
        className="u-mt-16"
        columns={getColumns(onAsignar, complaintSelected, [ROL.ADMINISTRADOR, ROL.RESPONSABLE].includes(role))}
        data={dataFiltered}
        forcePagination
        pageSize={PAGE_SIZE.LISTADO_ASIGNAR_DENUNCIA}
      />
    </div>
  );
};
AsignarDenuncia.propTypes = {
  setComplaintSelected: func.isRequired,
  complaintSelected: arrayOf(shape({})).isRequired,
};
AsignarDenuncia.defaultProps = {};

export default AsignarDenuncia;
